import React, { Component } from "react";
import PropTypes from "prop-types";
import DropDown from "MODULES/shared/components/DropDown/DropDown";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { Authorized } from "MODULES/shared/components";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { QUALITY_CONTROL, REPAIR } from "MODULES/users/constants";
import { hasRole } from "MODULES/users/helpers";
import ResolveForm from "./ResolveForm";

export default class Controls extends Component {
  state = {
    resolveModalOpen: false
  };

  openResolveModal = () => this.setState({ resolveModalOpen: true });

  closeResolveModal = () => this.setState({ resolveModalOpen: false });

  sendRequestAndClose = discrepancy => {
    this.props.resolve(discrepancy.id);
    return this.closeResolveModal();
  };

  render() {
    const { resolveModalOpen } = this.state;
    const { discrepancy, openEditModal } = this.props;
    const initialValues = {
      id: discrepancy.id,
      reason_for_resolution: discrepancy.reason_for_resolution
    };
    return (
      <DropDown icon="fa fa-fw fa-ellipsis-v" menuClass="dropdown-menu-right">
        <DropDownItem onClick={openEditModal}>
          <i className="fa fa-fw fa-pencil" />
          &nbsp;Edit
        </DropDownItem>
        <Authorized
          roles={[QUALITY_CONTROL]}
          authorizedIf={user =>
            hasRole(user.toJS(), REPAIR) && discrepancy.repairs_can_resolve}
        >
          {!discrepancy.resolved && (
            <DropDownItem key="resolve-action" onClick={this.openResolveModal}>
              <i className="fa fa-fw fa-check" />
              Resolve
            </DropDownItem>
          )}
          <Modal
            open={resolveModalOpen}
            key="resolve-modal"
            close={this.closeResolveModal}
            dialogClass="modal-sm"
          >
            <Header>
              <Close close={this.closeResolveModal} />
              <h4 className="modal-title">Resolve Discrepancy</h4>
            </Header>
            <ResolveForm
              discrepancy={discrepancy}
              closeResolveModal={this.closeResolveModal}
              initialValues={initialValues}
            />
          </Modal>
        </Authorized>
      </DropDown>
    );
  }
}

Controls.propTypes = {
  discrepancy: PropTypes.shape({}).isRequired,
  resolve: PropTypes.func.isRequired,
  openEditModal: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Discrepancies/Controls.jsx